// extracted by mini-css-extract-plugin
module.exports = {"TabTitle":"TabTitle_TabTitle__3m7J9","ActiveTabTitle":"TabTitle_ActiveTabTitle__2ooxL"};